export const siteInfoKeys = {
  all: ["siteInformation"] as const,
};

export const processRunKeys = {
  all: ["processRuns"] as const,
  lists: () => [...processRunKeys.all, "list"] as const,
  list: (query: {
    searchFilter: string;
    gridFilters: unknown;
    sortModel: unknown;
    page?: number;
    pageSize?: number;
  }) => [...processRunKeys.lists(), query] as const,
  details: () => [...processRunKeys.all, "detail"] as const,
  detail: (id: string) => [...processRunKeys.details(), id] as const,
  programs: (id: string) => [...processRunKeys.detail(id), "programs"] as const,
  comparison: (id: string, originalId: string, generatedId: string) =>
    [...processRunKeys.detail(id), "program-comparison", originalId, generatedId, "with-header"] as const,
};
